// Hook personalizado para la lógica de autenticación
// Centraliza el manejo de estado y validaciones del login

import { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import toast from 'react-hot-toast';

/**
 * Hook useAuthForm
 * 
 * Maneja la lógica del formulario de autenticación
 * 
 * @returns {Object} Estado y funciones del formulario
 */
export const useAuthForm = () => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Valida un campo específico
  const validateField = (name, value) => {
    const newErrors = { ...errors };
    
    switch (name) {
      case 'email':
        if (!value) {
          newErrors.email = 'El email es requerido';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          newErrors.email = 'Email inválido';
        } else {
          delete newErrors.email;
        }
        break;
        
      case 'password':
        if (!value) {
          newErrors.password = 'La contraseña es requerida';
        } else if (value.length < 6) {
          newErrors.password = 'Mínimo 6 caracteres';
        } else {
          delete newErrors.password;
        }
        break;
        
      default:
        break;
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Maneja el cambio de un campo
  const handleChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  // Valida todo el formulario
  const validateForm = () => {
    let isValid = true;
    
    // Validar email
    if (!validateField('email', formData.email)) {
      isValid = false;
    }
    
    // Validar contraseña
    if (!validateField('password', formData.password)) {
      isValid = false;
    }
    
    return isValid;
  };

  // Maneja el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      toast.error('Por favor corrige los errores del formulario');
      return;
    }
    
    try {
      setLoading(true);
      await login(formData.email, formData.password);
      toast.success('¡Bienvenido de vuelta!');
    } catch (error) {
      toast.error(error.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  // Resetea el formulario
  const resetForm = () => {
    setFormData({ email: '', password: '' });
    setErrors({});
    setLoading(false);
  };

  return {
    formData,
    errors,
    loading,
    handleChange,
    handleSubmit,
    resetForm,
  };
};
